import AllhomesHomepage from './allhomes-homepage';
export default AllhomesHomepage;